import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  REPORT_FWPROGRESS_FETCH,
  REPORT_QCDATA_FETCH,
  REPORT_SUMMARY_OVERVIEW_FETCH,
  REPORT_SUMMARY_FACTOR_FETCH,
  REPORT_SUMMARY_CARMODEL_FETCH,
  REPORT_LATEST_FETCH,
  REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH,
  REPORT_CUSTOMER_VOICE_FETCH,
  REPORT_RANKING_FETCH,
} from '../redux/actions/types';
import {
  reportFwProgressFetchSuccess,
  reportQCDataFetchSuccess,
  reportSummaryOverviewFetchSuccess,
  reportSummaryFactorFetchSuccess,
  reportSummaryCarModelFetchSuccess,
  reportLatestFetchSuccess,
  reportSummaryOverviewDefaultFetchSuccess,
  reportCustomerVoiceFetchSuccess,
  reportRankingFetchSuccess,
} from '../redux/actions/ReportActions';
import { showErrorMessage, hideLoader } from '../redux/actions/NotifyActions';
import { getErrorMessage } from '../util/apiUtil';
import axios from 'axios';
import _ from 'lodash';

// API
export const reportFwProgressFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/fwprogress/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportQCDataFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/qcdata/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportSummaryFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/dashboard-overall/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportLatestFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/latest/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportSummaryOverviewDefaultFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/dashboard-overall-default/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportCustomerVoiceFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/dashboard-voc/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

export const reportRankingFetchRequest = async payload => {
  let url = `${process.env.REACT_APP_API_SURVEY_URL}api/dashboard-ranking/`;
  let params = { ...payload };
  let auth = {
    username: process.env.REACT_APP_API_SURVEY_USER,
    password: process.env.REACT_APP_API_SURVEY_PASSWORD,
  };
  params = _.omitBy(params, _.isEmpty);

  return await axios
    .post(url, params, { auth })
    .then(response => response.data)
    .catch(error => {
      throw error;
    });
};

// WORKER
function* reportFwProgressFetch({ payload }) {
  try {
    const data = yield call(reportFwProgressFetchRequest, payload);
    if (data.success) {
      yield put(reportFwProgressFetchSuccess(data));
    }
    if (!data.success) {
      yield put(reportFwProgressFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportQCDataFetch({ payload }) {
  try {
    const data = yield call(reportQCDataFetchRequest, payload);
    if (data.success) {
      yield put(reportQCDataFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportQCDataFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportSummaryOverviewFetch({ payload }) {
  try {
    const data = yield call(reportSummaryFetchRequest, payload);
    if (data.success) {
      yield put(reportSummaryOverviewFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportSummaryOverviewFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportSummaryFactorFetch({ payload }) {
  try {
    const data = yield call(reportSummaryFetchRequest, payload);
    if (data.success) {
      yield put(reportSummaryFactorFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportSummaryFactorFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportSummaryCarModelFetch({ payload }) {
  try {
    const data = yield call(reportSummaryFetchRequest, payload);
    if (data.success) {
      yield put(reportSummaryCarModelFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportSummaryCarModelFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportLatestFetch({ payload }) {
  try {
    const data = yield call(reportLatestFetchRequest, payload);
    if (data.success) {
      yield put(reportLatestFetchSuccess(data));
    }
    if (!data.success) {
      yield put(reportLatestFetchSuccess(undefined));
    }
    yield put(hideLoader());
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportSummaryOverviewDefaultFetch({ payload }) {
  try {
    const data = yield call(reportSummaryOverviewDefaultFetchRequest, payload);
    if (data.success) {
      yield put(reportSummaryOverviewDefaultFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportSummaryOverviewDefaultFetchSuccess(undefined));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportCustomerVoiceFetch({ payload }) {
  try {
    const data = yield call(reportCustomerVoiceFetchRequest, payload);
    if (data.success) {
      yield put(reportCustomerVoiceFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportCustomerVoiceFetchSuccess(undefined));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

function* reportRankingFetch({ payload }) {
  try {
    const data = yield call(reportRankingFetchRequest, payload);
    console.log(data);
    if (data.success) {
      data.data.title = data.title;
      yield put(reportRankingFetchSuccess(data.data));
    }
    if (!data.success) {
      yield put(reportRankingFetchSuccess(undefined));
    }
  } catch (error) {
    yield put(showErrorMessage(getErrorMessage(error)));
  }
}

// WATCHER
function* reportFwProgressFetchWatcher() {
  yield takeEvery(REPORT_FWPROGRESS_FETCH, reportFwProgressFetch);
}

function* reportQCDataFetchWatcher() {
  yield takeEvery(REPORT_QCDATA_FETCH, reportQCDataFetch);
}

function* reportSummaryOverviewFetchWatcher() {
  yield takeEvery(REPORT_SUMMARY_OVERVIEW_FETCH, reportSummaryOverviewFetch);
}

function* reportSummaryFactorFetchWatcher() {
  yield takeEvery(REPORT_SUMMARY_FACTOR_FETCH, reportSummaryFactorFetch);
}

function* reportSummaryCarModelFetchWatcher() {
  yield takeEvery(REPORT_SUMMARY_CARMODEL_FETCH, reportSummaryCarModelFetch);
}

function* reportLatestFetchWatcher() {
  yield takeEvery(REPORT_LATEST_FETCH, reportLatestFetch);
}

function* reportSummaryOverviewDefaultFetchWatcher() {
  yield takeEvery(REPORT_SUMMARY_OVERVIEW_DEFAULT_FETCH, reportSummaryOverviewDefaultFetch);
}

function* reportCustomerVoiceFetchWatcher() {
  yield takeEvery(REPORT_CUSTOMER_VOICE_FETCH, reportCustomerVoiceFetch);
}

function* reportRankingFetchWatcher() {
  yield takeEvery(REPORT_RANKING_FETCH, reportRankingFetch);
}

export default function* rootSaga() {
  yield all([
    fork(reportFwProgressFetchWatcher),
    fork(reportQCDataFetchWatcher),
    fork(reportSummaryOverviewFetchWatcher),
    fork(reportSummaryFactorFetchWatcher),
    fork(reportSummaryCarModelFetchWatcher),
    fork(reportLatestFetchWatcher),
    fork(reportSummaryOverviewDefaultFetchWatcher),
    fork(reportCustomerVoiceFetchWatcher),
    fork(reportRankingFetchWatcher),
  ]);
}
